function time(value) {
  const milliseconds = Date.parse(String(value ?? ''))
  return Number.isFinite(milliseconds) ? milliseconds : null
}

/** Earliest timestamp for a live “Worked for” clock. */
export function timelineRunStartedAt({ publicActivity, activity = [] }) {
  const candidates = [
    time(publicActivity?.startedAt),
    ...activity.map((row) => time(row.startedAt ?? row.started_at)),
  ].filter((value) => value !== null)
  if (!candidates.length) return null
  return Math.min(...candidates)
}
